import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "title", "data-qa"]
const _hoisted_2 = { class: "gfu-promo-banner__holder" }
const _hoisted_3 = { class: "gfu-promo-banner__layout" }
const _hoisted_4 = ["href", "title"]
const _hoisted_5 = { class: "gfu-promo-banner__content" }
const _hoisted_6 = { class: "gfu-promo-banner__text-container" }
const _hoisted_7 = { class: "_flexcol _ai-c" }
const _hoisted_8 = ["data-title"]
const _hoisted_9 = ["data-title"]
const _hoisted_10 = ["data-title"]
const _hoisted_11 = ["data-title"]
const _hoisted_12 = ["data-title"]
const _hoisted_13 = { class: "gfu-promo-banner__actions _tac" }
const _hoisted_14 = { class: "gfu-promo-banner-display--small" }
const _hoisted_15 = { class: "gfu-promo-banner-display--medium" }
const _hoisted_16 = { class: "gfu-promo-banner-display--large" }
const _hoisted_17 = { class: "gfu-promo-banner__link-close" }
const _hoisted_18 = ["data-title"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_countdown = _resolveComponent("countdown")

  return ($data.visible)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: $options.projectUrlWithRef,
        class: _normalizeClass(['gfu-promo-banner', { 'gfu-promo-banner--closed': $data.closed }, $options.visibilityClass]),
        style: _normalizeStyle($options.backgroundColorStyle($props.variantLarge.backgroundStyle)),
        title: $props.projectName,
        onClick: _cache[1] || (_cache[1] = (...args) => ($options.onClick && $options.onClick(...args))),
        "data-qa": `advert-banner:${$props.projectAdvertID}`
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: "gfu-promo-banner-background gfu-promo-banner-display--small",
            style: _normalizeStyle($options.backgroundImageStyle($props.variantSmall.backgroundImageUrl))
          }, null, 4 /* STYLE */),
          _createElementVNode("span", {
            class: "gfu-promo-banner-background gfu-promo-banner-display--medium",
            style: _normalizeStyle($options.backgroundImageStyle($props.variantMedium.backgroundImageUrl))
          }, null, 4 /* STYLE */),
          _createElementVNode("span", {
            class: "gfu-promo-banner-background gfu-promo-banner-display--large",
            style: _normalizeStyle($options.backgroundImageStyle($props.variantLarge.backgroundImageUrl))
          }, null, 4 /* STYLE */)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            href: $options.projectUrlWithRef,
            title: $props.projectName,
            class: "gfu-promo-banner__head"
          }, [
            _createElementVNode("div", {
              class: "gfu-promo-banner-underlay gfu-promo-banner-display--small",
              style: _normalizeStyle($options.backgroundImageStyle($props.variantSmall.underlayImageUrl))
            }, [
              _createElementVNode("div", {
                class: "gfu-promo-banner-packshot gfu-promo-banner-display--small",
                style: _normalizeStyle($options.backgroundImageStyle($props.variantSmall.packshotImageUrl))
              }, null, 4 /* STYLE */)
            ], 4 /* STYLE */),
            _createElementVNode("div", {
              class: "gfu-promo-banner-underlay gfu-promo-banner-display--medium",
              style: _normalizeStyle($options.backgroundImageStyle($props.variantMedium.underlayImageUrl))
            }, [
              _createElementVNode("div", {
                class: "gfu-promo-banner-packshot gfu-promo-banner-display--medium",
                style: _normalizeStyle($options.backgroundImageStyle($props.variantMedium.packshotImageUrl))
              }, null, 4 /* STYLE */)
            ], 4 /* STYLE */),
            _createElementVNode("div", {
              class: "gfu-promo-banner-underlay gfu-promo-banner-display--large",
              style: _normalizeStyle($options.backgroundImageStyle($props.variantLarge.underlayImageUrl))
            }, [
              _createElementVNode("div", {
                class: "gfu-promo-banner-packshot gfu-promo-banner-display--large",
                style: _normalizeStyle($options.backgroundImageStyle($props.variantLarge.packshotImageUrl))
              }, null, 4 /* STYLE */)
            ], 4 /* STYLE */)
          ], 8 /* PROPS */, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", {
                  class: "gfu-promo-banner__title gfu-promo-banner-display--small text-stroke",
                  "data-title": $props.variantSmall.title,
                  style: _normalizeStyle({ '-webkit-text-stroke-color': $props.variantSmall.titleStyle })
                }, _toDisplayString($props.variantSmall.title), 13 /* TEXT, STYLE, PROPS */, _hoisted_8),
                _createElementVNode("span", {
                  class: "gfu-promo-banner__title gfu-promo-banner-display--medium text-stroke",
                  "data-title": $props.variantMedium.title,
                  style: _normalizeStyle({ '-webkit-text-stroke-color': $props.variantMedium.titleStyle })
                }, _toDisplayString($props.variantMedium.title), 13 /* TEXT, STYLE, PROPS */, _hoisted_9),
                _createElementVNode("span", {
                  class: "gfu-promo-banner__title gfu-promo-banner-display--large text-stroke",
                  "data-title": $props.variantLarge.title,
                  style: _normalizeStyle({ '-webkit-text-stroke-color': $props.variantLarge.titleStyle }),
                  "data-qa": "advert-banner:TitleLarge"
                }, _toDisplayString($props.variantLarge.title), 13 /* TEXT, STYLE, PROPS */, _hoisted_10),
                _createElementVNode("span", {
                  class: _normalizeClass(['gfu-promo-banner__subtitle gfu-promo-banner-display--medium', {'text-stroke': $options.subtitleLabelMedium }]),
                  "data-title": $options.subtitleLabelMedium,
                  style: _normalizeStyle({ '-webkit-text-stroke-color': $props.variantMedium.titleStyle })
                }, _toDisplayString($options.subtitleLabelMedium), 15 /* TEXT, CLASS, STYLE, PROPS */, _hoisted_11),
                _createElementVNode("span", {
                  class: _normalizeClass(['gfu-promo-banner__subtitle gfu-promo-banner-display--large', {'text-stroke': $options.subtitleLabelLarge }]),
                  "data-title": $options.subtitleLabelLarge,
                  style: _normalizeStyle({ '-webkit-text-stroke-color': $props.variantLarge.titleStyle }),
                  "data-qa": "advert-banner:SubTitleLarge"
                }, _toDisplayString($options.subtitleLabelLarge), 15 /* TEXT, CLASS, STYLE, PROPS */, _hoisted_12)
              ]),
              ($options.showCountDown)
                ? (_openBlock(), _createBlock(_component_countdown, {
                    key: 0,
                    "pad-numbers": true,
                    class: "gfu-promo-banner__countdown",
                    timestamp: $options.countdownDate,
                    "data-qa": "advert-banner:EndDate"
                  }, null, 8 /* PROPS */, ["timestamp"]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", null, [
                _createElementVNode("span", {
                  class: "gfu-btn gfu-btn--soft gfu-btn--block _px-5 gfu-btn--wide _whs-nw gfu-promo-banner__btn",
                  style: _normalizeStyle($options.buttonStyle($props.variantSmall.titleStyle)),
                  "data-qa": "advert-banner:ActionLabel"
                }, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString($props.variantSmall.actionLabel), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_15, _toDisplayString($props.variantMedium.actionLabel), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_16, _toDisplayString($props.variantLarge.actionLabel), 1 /* TEXT */)
                ], 4 /* STYLE */)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", {
                  "data-title": _ctx.Resources.Homepage.HideAdvertBannerButton,
                  class: "gfu-link gfu-promo-banner__link text-stroke",
                  style: _normalizeStyle({ '-webkit-text-stroke-color': $props.variantSmall.titleStyle }),
                  onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onClose && $options.onClose(...args)), ["prevent"])),
                  "data-qa": "advert-banner:Hide"
                }, _toDisplayString(_ctx.Resources.Homepage.HideAdvertBannerButton), 13 /* TEXT, STYLE, PROPS */, _hoisted_18)
              ])
            ])
          ])
        ])
      ], 14 /* CLASS, STYLE, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}